import { render, staticRenderFns } from "./AccessDevices.vue?vue&type=template&id=6d5174c4&scoped=true"
import script from "./AccessDevices.vue?vue&type=script&lang=ts"
export * from "./AccessDevices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5174c4",
  null
  
)

export default component.exports